//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'YtoModal',
    data() {
        return {
            visible: false,
            obj: {
                type: 'confirm',
                confirm: () => {},
                cancel: () => {}
            }
        };
    },
    methods: {
        open(obj) {
            this.visible = true;
            this.obj = obj;
            this.$emit('open');
        },
        close() {
            this.visible = false;
        },
        confirm() {
            if (this.obj.confirm) {
                this.obj.confirm(() => {
                    this.visible = false;
                });
            } else {
                this.visible = false;
            }
        },
        cancel() {
            if (this.obj.cancel) {
                this.obj.cancel(() => {
                    this.visible = false;
                });
            } else {
                this.visible = false;
            }
        }

    }
};



// WEBPACK FOOTER //
// ./src/components/yto-modal.vue